import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import { trpc } from "@mnk/frontend/lib/trpc";
import type { GetItem } from "@mnk/shared/models/item";
import { useState } from "react";

interface Props {
  onClose: () => void;
  item: GetItem;
  afterDeleteProject: () => void;
}

export const DeleteProjectModal = ({ onClose, item, afterDeleteProject }: Props) => {
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteProjectMutation = trpc.deleteProject.useMutation();

  const onSubmit = async () => {
    setProcessing(true);
    try {
      await deleteProjectMutation.mutateAsync({
        itemId: item.id,
      });
      afterDeleteProject();
    } catch (error) {
      setError("プロジェクトの削除に失敗しました");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          onClose();
        }
      }}
    >
      <div className="w-full h-full flex justify-center items-center">
        <div
          className="bg-white rounded-lg shadow-lg w-96 flex flex-col"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              onClose();
            }
          }}
        >
          <div className="bg-gray-100 rounded-t-lg flex justify-between items-center p-2 relative h-10 flex-shrink-0">
            <h2 className="text-center text-md font-bold mx-auto">プロジェクトを削除</h2>
          </div>
          <div className="p-4 flex flex-col gap-4 rounded-b-lg">
            <p className="text-sm text-gray-700 text-center">
              プロジェクト「{item.name}」を削除します。
              <br />
              この操作は取り消せません。よろしいですか？
            </p>

            {error && <p className="text-sm text-red-500 text-center">{error}</p>}

            <div className="flex gap-2">
              <PrimaryButton className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800" onClick={onClose}>
                キャンセル
              </PrimaryButton>
              <PrimaryButton
                className="flex-1 bg-red-500 hover:bg-red-600 text-white"
                onClick={async (e) => {
                  e.preventDefault();
                  await onSubmit();
                  onClose();
                }}
                disabled={processing}
              >
                削除する
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
